module.exports = __webpack_public_path__ + "static/Banner-7-3bd15ce20104d4c5863554d861722417.png";